const dsList = (($) => {

    const url = 'index.php?route=account/shopping_lists',
        list_slider = '.slider-list',
        list_content = 'div.slider-list',
        list_new_form = 'div.new-list-name',
        delete_modal = 'div.shopping-list-delete-modal',
        rec_btn = 'input.shopping-list-add[data-type="recurring"]',
        rec_extra = 'p#list-ro-extra';
    let list_to_delete = 0;

    function modalOpen(el, type, product_obj = '') {
        if (!doorstep.customer_id) {
            location.href = dsUtilities.urlLogin();
        } else {
            const product = product_obj instanceof Object ? product_obj : (type === 'product' ? dsProduct.getProduct(el) : {});
            doorstep.list_type = type;
            doorstep.list_product = product;
            doorstep.list_product.quantity = product.quantity_start ?? 1;
            regularCheck(product.regular)
            $(doorstep.list_type === 'product' ? 'input#shopping-list-input' : 'input#save-list-input').val('');
            if (doorstep.list_type === 'product') {
                html(product);
                slider();
                events();
            }
            $(modalName()).css('display', 'block');
        }
    }

    function regularCheck(regular) {
        if (regular || regular === undefined) {
            $(this).removeAttr('disabled');
        } else {
            $(rec_extra).addClass('hide');
            $(rec_btn).each(function () {
                $(this).attr('disabled', true);
            });
            $(rec_extra).removeClass('hide');
        }
    }

    function modalClose() {
        doorstep.list_product = {};
        doorstep.list_new = [];
        doorstep.listType = '';
        $(rec_btn).each(function () {
            $(this).removeAttr('disabled');
        });
        $(rec_extra).addClass('hide');
        $(modalName()).css('display', 'none');
        $(modalSelect()).prop('checked', false);
        $(modalError()).addClass('hide').html('');
        if (doorstep.list_type === 'product') {
            $(list_slider).slick('unslick');
        }
    }

    function delModal(el) {
        list_to_delete = $(el).closest('div.shopping-list').attr('data-id');
        $(delete_modal).removeClass('hide');
    }

    function add(el) {
        const list = $(el).closest('div.shopping-list').attr('data-id');
        $.ajax({
            url: `${url}/add_to_cart`,
            type: 'post',
            data: { list: list },
            dataType: 'json',
            success: function (response) {
                if (response.error !== undefined && !response.error) {
                    location.href = `${url}&mybox=1&mixed=${response.mixed ? '1' : '0'}`;
                }
            }
        });
    }

    function listAdd(el) {
        const sel = $(`${modalSelect()}:checked`);
        if (sel.length > 0) {
            $(sel).each(function () {
                const type = $(this).data('type'),
                    subview = dsUtilities.getSubView(el),
                    name = type === 'new' ? (subview === 'product' ? $('input#shopping-list-input').val().trim() : $('input#save-list-input').val().trim()) : '';
                if (((type === 'new' && name.length > 0) || type !== 'new') && sel.length > 0) {
                    ajaxAdd(type, $(this).data('id'), name).done(function (response) {
                        if (response.error) {
                            $(modalError()).removeClass('hide').html(response.message);
                            return false;
                        } else {
                            if (type === 'new') {
                                doorstep.list_new.push({'id': response.id, 'name': name});
                                $('input#shopping-list-input').attr('checked', false).val('');
                                $('li.shopping-list-new-li').before(
                                    `<li><label class="list-select"><input class="shopping-list-add" type="checkbox" data-id="${response.id}" data-type="list"><span class="checkmark"></span>{response.name}</label></li>`
                                );
                            }
                        }
                    });
                    dsUtilities.doModal('list', doorstep.type === 'product' ? 'Your product has been successfully added.' : 'Your list has been successfully saved.');
                    modalClose();
                }
            });
        }
    }

    function listDelete() {
        $.ajax({
            url: `${url}/delete`,
            type: 'post',
            data: { list: list_to_delete },
            dataType: 'json',
            success: function (response) {
                if (response.error !== undefined && !response.error) {
                    location.reload();
                }
            }
        });
    }

    function html() {
        let product_html = '', new_lists = '', num = 0;
        product_html = listItemHTML(doorstep.list_product, num);
        num++;
        if (!doorstep.list_product.bundle) {
            doorstep.list_product.child_products.forEach(function (product) {
                product_html += listItemHTML(product, num);
                num++;
            });
        }
        doorstep.list_new.forEach(function (list) {
            new_lists += `<li><label class="list-select"><input class="shopping-list-add" type="checkbox" data-id="${list.id}" data-type="list"><span class="checkmark"></span>${list.name}</label></li>`;
        });
        $('li#shopping-list-new-li').before(new_lists);
        $('span#shopping-list-image').html(`<img src="/image/${doorstep.list_product.image}" class="product-img add-to-list-img" alt="${doorstep.list_product.name}"/><h1></h1>`);
        $('h3#shopping-list-title').html(doorstep.list_product.name);
        $(list_content).html(product_html);
    }

    function listItemHTML(product, key) {
        let html = `<a class="slider-list__item" data-key="${key}" href="javascript:void(0)">`;
        html += `<div class="details">`
        if (product.bundle) {
            html += `<div class="prices"><p class="black"><br>Add bundle to my box</p><span class="price">&nbsp;</span><span class="price-kg">&nbsp;</span></div>`;
        } else {
            html += `<div class="prices"><p class="black">${product.size_free}</p><span class="price">${product.price_display}&nbsp;</span><span class="price-kg">${product.unit_price}</span></div>`;
        }
        html += `<div class="add-to-box add-deduct-item-row"><button class="green-btn circle deduct">&nbsp;</button><p class="p black shopping-list-quantity">${product.quantity_start}</p>
<button class="green-btn circle add">&nbsp;</button></div></div></a>`;
        return html;
    }

    function slider() {
        const prev = '.prev-arrow-list',
            next = '.next-arrow-list'
        $(list_slider).slick({
            dots         : true,
            slidesToShow : 1,
            prevArrow    : $(prev),
            nextArrow    : $(next),
            responsive   : [
                {
                    breakpoint : 1023,
                    settings   : {
                        prevArrow    : $(prev),
                        nextArrow    : $(next),
                        slidesToShow : 1,
                        dots         : true
                    }
                }
            ]
        });
    }

    function events() {
        $(`${modalName()} button.deduct, ${modalName()} button.add`).off('click').on('click', function (e) {
            e.preventDefault();
            const key = parseInt($(this).closest('.slider-list__item').attr('data-key'));
            dsProduct.doIncrement(this, 'shopping-list', false, key > 0 ? doorstep.list_product.child_products[key - 1] : doorstep.list_product);
        });
    }

    function slideNew(el) {
        $(el).is(':checked') ? $(list_new_form).slideDown('slow') : $(list_new_form).slideUp('slow');
    }

    function ajaxAdd(type, id, name) {
        return $.ajax({
            url: `index.php?route=account/${type === 'list' || type === 'new' ? 'shopping_lists' : 'recurring_orders'}/add_json`,
            type: 'post',
            data: ajaxData(type, id, name),
            dataType: 'json'
        });
    }

    function ajaxData(type, id, name) {
        let data = {};
        if (doorstep.list_type === 'product') {
            const product = getProductFromKey(parseInt($('li.slick-active').find('button').text()) - 1);
            data = {
                product   : product.id,
                quantity  : doorstep.list_product.quantity ?? product.quantity_start,
                name      : product.name,
                regular   : product.regular,
                fractions : product.fractions,
                brand     : product.brand,
                size      : product.size_free
            }
        }
        return Object.assign({ id: id, type: type, list_name: name, action: doorstep.list_type }, data);
    }

    function getProductFromKey(key) {
        return key > 0 ? doorstep.list_product.child_products[key - 1] : doorstep.list_product;
    }

    function modalName() {
        return doorstep.list_type === 'product' ? 'div#add-to-list-modal' : 'div#save-list-modal'
    }

    function modalSelect() {
        return `${modalName()} input.shopping-list-add`;
    }

    function modalError() {
        return doorstep.list_type === 'product' ? 'div#shopping-list-error' : 'div#save-list-error'
    }

    $(document).ready(function () {

        $('a.shop-list-delete').on('click',function () {
            delModal($(this));
        });

        $('button.shop-list-add').on('click',function () {
            add(this);
        });

        $('input#shopping-list-new, input#save-list-new').on('click',function () {
            slideNew(this);
        });

        $('button.shopping-list-cancel').on('click',function(){
            modalClose();
        });

        $('button.shopping-list-confirm').on('click',function () {
            listAdd(this);
        });

        $(`${delete_modal} button.modal-btn-delete`).on('click',function (e) {
            e.preventDefault();
            listDelete();
        });

        $(`${delete_modal} button.delete-close, ${delete_modal} img.close-modal`).on('click',function (e) {
            e.preventDefault();
            list_to_delete = 0;
            $(delete_modal).addClass('hide');
        });

        $(list_slider).on('init', function() {
            if ($('a.slider-list__item').length === 1) {
                $('div.slider-list').append('<ul class="slick-dots" role="tablist"></ul>');
            }
        }).on('afterChange', function(e, s, key) {
            const product = getProductFromKey(key);
            regularCheck(product.regular);
        });

    });

    return {
        modalOpen : modalOpen
    }

})(jQuery);